import reactStringReplace from 'react-string-replace';
import ExternalLink from 'common/components/ExternalLink';

interface TextWithExternalLinkProps {
  text: string;
  shouldNotTranslate?: boolean;
}

function TextWithExternalLink({ text, shouldNotTranslate = false }: TextWithExternalLinkProps) {
  const aTagRegExp = /(<a[^>]+href=["']{1}[^"'\s]+["']{1}[^>]*>.+?<\/a>)/g;
  const urlTextRegExp = /<a[^>]+href=["']{1}(?<url>[^"'\s]+)+["']{1}[^>]*>(?<text>.+)+<\/a>/i;

  const replacedText = reactStringReplace(text, aTagRegExp, (aTag, index) => {
    const match = urlTextRegExp.exec(aTag);
    const aTagProps = match ? match.groups : null;

    return aTagProps ?
        <ExternalLink key={index} url={aTagProps.url} text={aTagProps.text} />
      : aTag;
  });

  return <span {...(shouldNotTranslate ? { 'data-notranslate': true } : {})}>{replacedText}</span>;
}

export default TextWithExternalLink;
